import { useLocale } from '@/lib/hooks/use-locale';

type Props = {
    decimals?: number;
    children: string | number | undefined | null;
    defaultEmpty?: string;
    showEmptyIfZero?: boolean;
    showPlusSignIfPositive?: boolean;
};

export const NumberOrEmpty: React.FC<Props> = ({
    decimals = 0,
    defaultEmpty = '-',
    children,
    showEmptyIfZero = false,
    showPlusSignIfPositive = false,
}) => {
    const { locale } = useLocale();

    const formatNumber = () => {
        const cleanValue = Number(children);

        if (Number.isNaN(cleanValue) || !Number.isFinite(cleanValue)) {
            return defaultEmpty;
        } else if (cleanValue === 0 && showEmptyIfZero) {
            return defaultEmpty;
        } else {
            return new Intl.NumberFormat(locale, {
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals,
                signDisplay: showPlusSignIfPositive ? 'always' : 'auto',
            }).format(cleanValue);
        }
    };

    const formattedValue = formatNumber();

    return <>{formattedValue}</>;
};
